/* Velvære story page (vv-story). Step navigation, back, skip, progress, reviews carousel, lazy backgrounds, confetti, tracking.
   No dependencies. Runs once per page, re-runs for a section the theme editor reloads; every init marks its root so nothing is wired twice. */
(function () {
  if (window.__vvStory) { return; }
  window.__vvStory = true;
  function qs(root, s) { return root.querySelector(s); }
  function qsa(root, s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function track(name) {
    if (!name) return;
    var w = window;
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ event: name });
    if (typeof w.fbq === 'function') { try { w.fbq('trackCustom', name); } catch (e) {} }
    if (typeof w.gtag === 'function') { try { w.gtag('event', name); } catch (e) {} }
    /* Shopify custom pixels (Settings → Customer events) subscribe to these with analytics.subscribe(name, …); the Meta app pixel runs in that sandbox, so this is the route to Meta */
    if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') { try { w.Shopify.analytics.publish(name, { page: 'story' }); } catch (e) {} }
  }

  function initStory(root) {
    if (root.__vvInit) return; root.__vvInit = true;
    var steps = qsa(root, '.step');
    if (!steps.length) return;
    var back = qs(root, '[data-story-back]');
    var skip = qs(root, '[data-story-skip]');
    var segs = qsa(root, '.progress__seg');
    var evStep = root.getAttribute('data-ev-step') || 'step_{n}_complete';
    var evSkip = root.getAttribute('data-ev-skip') || 'offer_skip';
    var evOffer = root.getAttribute('data-ev-offer') || 'offer_click';
    var cur = 0;

    /* Backgrounds: the first is inline, the second is set now, the rest are set when their step arrives; everything preloads after load */
    function setBg(step) {
      var bg = qs(step, '.bg[data-src]');
      if (bg) { bg.style.setProperty('--bg-img', "url('" + bg.getAttribute('data-src') + "')"); bg.removeAttribute('data-src'); }
    }
    function preloadAll() {
      var list = steps.map(function (s) {
        if (s.classList.contains('is-active')) return null;
        var bg = qs(s, '.bg'); if (!bg) return null;
        var m = (bg.getAttribute('style') || '').match(/--bg-img:\s*url\(['"]?([^)'"]+)/);
        return bg.getAttribute('data-src') || (m ? m[1] : null);
      }).filter(function (u) { return !!u; });
      qsa(root, '.step img[loading="lazy"]').forEach(function (im) { list.push(im.getAttribute('src') || ''); });
      (function next() { var u = list.shift(); if (!u) return; var im = new Image(); im.onload = im.onerror = next; im.src = u; })();
    }
    if (document.readyState === 'complete') preloadAll(); else window.addEventListener('load', preloadAll);

    function paint() {
      segs.forEach(function (seg, i) { seg.classList.toggle('is-done', i <= cur); });
      if (back) back.hidden = cur === 0;
      if (skip) skip.hidden = cur === steps.length - 1;
    }
    function go(i, complete) {
      if (i < 0 || i >= steps.length || i === cur) return;
      var from = steps[cur], to = steps[i];
      if (complete) track(evStep.replace('{n}', String(cur + 1)));
      from.classList.add('is-leaving'); from.classList.remove('is-active');
      setTimeout(function () { from.classList.remove('is-leaving'); }, reduced ? 0 : 380);
      setBg(to);
      to.classList.add('is-active');
      cur = i; to.scrollTop = 0; paint();
    }
    qsa(root, '[data-story-next]').forEach(function (b) { b.addEventListener('click', function () { go(cur + 1, true); }); });
    if (back) back.addEventListener('click', function () { go(cur - 1, false); });
    if (skip) skip.addEventListener('click', function () { track(evSkip); go(steps.length - 1, false); });
    qsa(root, '[data-story-offer]').forEach(function (a) { a.addEventListener('click', function () { track(evOffer); }); });

    /* Reviews carousel: scroll-snap, dots, mouse drag, arrow keys */
    var car = qs(root, '[data-carousel]'), dots = qsa(root, '[data-dot]');
    if (car && dots.length) {
      var cards = qsa(car, '.rev');
      var mark = function (k) { dots.forEach(function (d, j) { d.classList.toggle('is-active', j === k); }); };
      car.addEventListener('scroll', function () { var w = car.clientWidth || 1; mark(Math.min(cards.length - 1, Math.round(car.scrollLeft / w))); }, { passive: true });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { car.scrollTo({ left: j * car.clientWidth, behavior: 'smooth' }); }); });
      var drag = null;
      car.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') { drag = { x: e.clientX, left: car.scrollLeft }; car.classList.add('is-dragging'); } });
      window.addEventListener('pointermove', function (e) { if (drag) car.scrollLeft = drag.left - (e.clientX - drag.x); });
      window.addEventListener('pointerup', function () { drag = null; car.classList.remove('is-dragging'); });
      car.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') car.scrollBy({ left: car.clientWidth, behavior: 'smooth' });
        if (e.key === 'ArrowLeft') car.scrollBy({ left: -car.clientWidth, behavior: 'smooth' });
      });
    }

    /* Confetti on the offer step: 52 CSS pieces, colours from the section setting */
    var conf = qs(root, '.confetti');
    if (conf && !conf.children.length && !reduced) {
      var colors = (conf.getAttribute('data-colors') || '#1ca1f2,#5bbcf6,#9dd6fa,#0b5fa5,#ffffff,#eef5fb').split(',');
      for (var k = 0; k < 52; k++) {
        var p = document.createElement('span'), round = k % 6 === 0;
        p.className = 'confetti__piece' + (round ? ' is-round' : '');
        var sz = 6 + Math.round(Math.random() * 5);
        p.style.cssText = 'left:' + (Math.random() * 100).toFixed(2) + '%;width:' + sz + 'px;height:' + (round ? sz : sz + Math.round(Math.random() * 8)) + 'px;background:' + colors[k % colors.length].trim() +
          ';animation-delay:' + (Math.random() * 1.1).toFixed(2) + 's;animation-duration:' + (2.6 + Math.random() * 1.9).toFixed(2) + 's;--drift:' + Math.round(Math.random() * 80 - 40) + 'px;--spin:' + Math.round(540 + Math.random() * 540) + 'deg';
        conf.appendChild(p);
      }
    }

    setBg(steps[0]); if (steps[1]) setBg(steps[1]);
    steps[0].classList.add('is-active'); paint();
  }

  function init(root) { qsa(root, '[data-vv-story]').forEach(initStory); if (root.matches && root.matches('[data-vv-story]')) initStory(root); }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();